import { FC } from "react";
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from "@mui/material";
import { CheckboxTheme } from "./checkbox.constants";
import classnames from "classnames";
import styles from "./checkbox.styles.module.scss";

type CheckboxProps = {
  theme?: `${CheckboxTheme}`,
  ariaLabel?: string,
  label?: MuiFormControlLabelProps["label"] | string,
  isChecked?: boolean,
  isDisabled?: boolean,
  isIndeterminate?: boolean,
  onChange?: MuiCheckboxProps["onChange"];
  additionalProps?: Partial<MuiFormControlLabelProps>;
  additionalControlProps?: Partial<MuiCheckboxProps>,
};

export const CheckboxComponent: FC<CheckboxProps> = ({
  theme = CheckboxTheme.LIGHT,
  ariaLabel,
  label,
  isChecked = false,
  isDisabled = false,
  isIndeterminate = false,
  onChange,
  additionalProps = {},
  additionalControlProps = {},
}) => {
  const checkboxControl = (
    <MuiCheckbox
      {...additionalControlProps}
      aria-label={ariaLabel}
      disableFocusRipple={true}
      disableRipple={true}
      onChange={onChange}
      disabled={isDisabled}
      checked={isChecked}
      indeterminate={isIndeterminate}
      classes={{
        root: classnames(
          styles.root,
          {
            [CheckboxTheme.DARK]: styles.themeDark,
            [CheckboxTheme.LIGHT]: styles.themeLight,
          }[theme]
        ),
        checked: styles.checked,
        indeterminate: styles.checked,
        disabled: styles.disabled,
      }}
      tabIndex={0}
    />
  );

  if (!label) {
    return checkboxControl;
  }

  return (
    <MuiFormControlLabel
      {...additionalProps}
      disabled={isDisabled}
      label={label}
      classes={{
        label: classnames(
          styles.label,
          styles.labelRoot,
          {
            [CheckboxTheme.DARK]: styles.themeDark,
            [CheckboxTheme.LIGHT]: styles.themeLight,
          }[theme]
        ),
        disabled: styles.disabled,
      }}
      control={checkboxControl}
    />
  );
};
